export const UPDATEFILTERDATA = 'UPDATEFILTERDATA';
export const UPDATEFILTER = 'UPDATEFILTER';
export const GETSCHOOL = 'GETSCHOOL';
